import { Table as MantineTable } from '@mantine/core';
import { forwardRef } from 'react';
export const GoodTableTd = forwardRef(({ sticky, children, ...props }, ref) => {
    if (sticky !== undefined) {
        const { placement = 'left', noShadow = false, offset = 0 } = typeof sticky === 'boolean' ? {} : sticky;
        return (<MantineTable.Td ref={ref} pos='sticky' left={placement === 'left' ? offset : undefined} right={placement === 'right' ? offset : undefined} {...props} className={['stickyTd', !noShadow && 'stickyTd__scrollShadow', props.className].filter(Boolean).join(' ')} style={{
                zIndex: 2,
                ...props.style,
            }} bg={props.bg ?? 'var(--mantine-color-body)'}>
          {children}
        </MantineTable.Td>);
    }
    return (<MantineTable.Td ref={ref} {...props}>
        {children}
      </MantineTable.Td>);
});
